import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
import { usePlayer } from '../contexts/PlayerContext';
const OPTIONS = [15, 30, 45, 60];

/** Sleep fade: the set dips to silence over the last 20 seconds, then pauses. */
export function SleepMenu() {
  const {
    sleepSecondsLeft,
    setSleepMinutes
  } = usePlayer();
  const [open, setOpen] = useState(false);
  const hostRef = useRef<HTMLDivElement | null>(null);
  const armed = sleepSecondsLeft !== null;
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (hostRef.current && !hostRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const label = armed ? `${Math.floor((sleepSecondsLeft ?? 0) / 60)}:${String((sleepSecondsLeft ?? 0) % 60).padStart(2, '0')}` : null;
  return <div ref={hostRef} className="relative" data-id="element-167" data-mp="1n6lb3n0nexll">
      <button type="button" onClick={() => setOpen(o => !o)} aria-haspopup="menu" aria-expanded={open} aria-label={armed ? `Sleep fade in ${label}` : 'Set sleep fade'} className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1.5 text-xs transition-colors duration-150 ease-night focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft ${armed ? 'border-iris-soft/60 text-iris-soft' : 'border-ink-line text-muted hover:text-cream'}`} data-id="element-168" data-mp="1n5tsrdw2awd9">
        <MoonIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" data-mp="198evjmzkhkaq" />
        {label && <span className="tabular-nums" data-id="element-170" data-mp="2ym9z8hpn22nz">{label}</span>}
      </button>

      <AnimatePresence data-id="element-171" data-mp="33jjx8lr3fmnf">
        {open && <motion.div role="menu" initial={{
        opacity: 0,
        scale: 0.96,
        y: 4
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute bottom-11 right-0 z-30 w-44 origin-bottom-right rounded-lg border border-ink-line bg-ink-panel p-2 shadow-2xl shadow-black/60" data-id="element-172" data-mp="33iiio7avci0y">
            <p className="px-2 pb-1.5 text-[11px] text-muted" data-id="element-173" data-mp="3ku730dw9851e">Fade out and stop in</p>
            {OPTIONS.map(minutes => <button key={minutes} type="button" role="menuitem" onClick={() => {
          setSleepMinutes(minutes);
          setOpen(false);
        }} className="block w-full rounded px-2 py-1.5 text-left text-sm text-cream transition-colors duration-150 ease-night hover:bg-ink-raised focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft" data-id="element-174" data-mp="3fvcm5hhukqjx">
                {minutes} minutes
              </button>)}
            {armed && <button type="button" role="menuitem" onClick={() => {
          setSleepMinutes(null);
          setOpen(false);
        }} className="mt-1 block w-full rounded border-t border-ink-line px-2 py-1.5 text-left text-sm text-muted transition-colors duration-150 ease-night hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft" data-id="element-175" data-mp="ezlc1556iowv">
                Cancel fade
              </button>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}